module.exports = __webpack_public_path__ + "static/media/device-item-icon.9feced70.svg";